import { getVoucherCode, getOnecomConfig } from "store/selectors";
import { getNormalizedCartItems } from "../../utils";

const beginCheckout = () => (dispatch, getState) => {
  const state = getState();
  const coupon = getVoucherCode(state);
  const items = getNormalizedCartItems(state);
  const { currency } = getOnecomConfig(state) || {};
  window.GTM.pushBeginCheckout({ coupon, items, currency });
};

export default beginCheckout;
